<template>
  <v-container
    fluid
    class="pa-0 ma-0"
    style="height: 80vh; display: flex; flex-direction: column;"
  >
    <div class="mapa-body">
      <div class="mapa-sidebar">
        <div class="mapa-sidebar__search">
          <v-text-field
            v-model="busca"
            dense
            outlined
            hide-details
            placeholder="Buscar motorista, romaneio..."
            prepend-inner-icon="mdi-magnify"
            class="mapa-sidebar__input"
          />
        </div>

        <div
          v-if="carregando && motoristas.length === 0"
          class="mapa-sidebar__loading"
        >
          <v-icon
            class="mapa-spinner mr-2"
            :style="{ color: corPrimaria }"
          >
            mdi-cached
          </v-icon>
          Carregando...
        </div>

        <div class="mapa-sidebar__lista">
          <div
            v-for="motorista in motoristasFiltrados"
            :key="motorista.id_romaneio"
            class="mapa-driver-card"
            :class="{ 'mapa-driver-card--selecionado': motoristaSelecionado && motoristaSelecionado.id_romaneio === motorista.id_romaneio }"
            @click="selecionarMotorista(motorista)"
          >
            <div
              class="mapa-driver-card__avatar"
              :style="{ background: getAvatarBg(motorista), color: getStatusRomaneioColor(motorista.status_romaneio) }"
            >
              {{ getIniciais(motorista.nome_motorista) }}
            </div>
            <div class="mapa-driver-card__info">
              <div class="mapa-driver-card__nome">
                {{ motorista.nome_motorista }}
              </div>
              <div class="mapa-driver-card__sub">
                {{ motorista.nome_transportador }}
              </div>

              <div class="mapa-driver-card__data">
                {{ motorista.data }}
              </div>
            </div>
            <div
              class="mapa-driver-card__dot"
              :style="{ background: getStatusRomaneioColor(motorista.status_romaneio) }"
            />
          </div>

          <div
            v-if="!carregando && motoristasFiltrados.length === 0"
            class="mapa-sidebar__vazio"
          >
            Nenhum motorista em rota.
          </div>
        </div>
      </div>

      <div class="mapa-area">
        <div
          id="mapMotoristas"
          class="mapa-canvas"
        />
        <div class="mapa-overlay-atualizacao">
          <div class="mapa-overlay-atualizacao__header">
            <v-icon small>
              mdi-refresh
            </v-icon>

            <span>
              {{ contagemRegressiva }}s
            </span>
          </div>

          <v-select
            v-model="intervaloPing"
            :items="opcoesIntervalo"
            item-text="label"
            item-value="valor"
            dense
            hide-details
            solo
            flat
            class="mapa-overlay-atualizacao__select"
            @change="reiniciarPing"
          />
        </div>

        <transition name="slide-up">
          <div
            v-if="motoristaSelecionado"
            class="mapa-detalhe-card"
          >
            <div class="mapa-detalhe-card__header">
              <div
                class="mapa-driver-card__avatar mapa-detalhe-card__avatar"
                :style="{ background: getAvatarBg(motoristaSelecionado), color: getStatusRomaneioColor(motoristaSelecionado.status_romaneio) }"
              >
                {{ getIniciais(motoristaSelecionado.nome_motorista) }}
              </div>
              <div class="mapa-detalhe-card__titulo">
                <div class="mapa-detalhe-card__nome">
                  {{ motoristaSelecionado.nome_motorista }}
                </div>
                <div class="mapa-detalhe-card__transportadora">
                  {{ motoristaSelecionado.nome_transportador }}
                </div>
              </div>
              <v-btn
                icon
                x-small
                class="ml-auto"
                @click="motoristaSelecionado = null"
              >
                <v-icon small>
                  mdi-close
                </v-icon>
              </v-btn>
            </div>
            <div class="mapa-detalhe-card__body">
              <div class="mapa-detalhe-row">
                <span class="mapa-detalhe-row__label">Entrega</span>
                <span class="mapa-detalhe-row__val">{{ motoristaSelecionado.id_romaneio }}</span>
              </div>
              <div class="mapa-detalhe-row">
                <span class="mapa-detalhe-row__label">Status Entrega</span>
                <span class="mapa-detalhe-row__val">{{ motoristaSelecionado.status_romaneio }}</span>
              </div>
              <div class="mapa-detalhe-row">
                <span class="mapa-detalhe-row__label">Velocidade</span>
                <span class="mapa-detalhe-row__val">{{ motoristaSelecionado.velocidade }} km/h</span>
              </div>
              <div class="mapa-detalhe-row">
                <span class="mapa-detalhe-row__label">Precisão GPS</span>
                <span class="mapa-detalhe-row__val">{{ motoristaSelecionado.precisao }}m</span>
              </div>
              <div class="mapa-detalhe-row">
                <span class="mapa-detalhe-row__label">Coordenadas</span>
                <span class="mapa-detalhe-row__val">
                  {{ parseFloat(motoristaSelecionado.latitude).toFixed(5) }},
                  {{ parseFloat(motoristaSelecionado.longitude).toFixed(5) }}
                </span>
              </div>
              <div class="mapa-detalhe-row mapa-detalhe-row--destaque">
                <span class="mapa-detalhe-row__label">Última posição</span>
                <span class="mapa-detalhe-row__val">{{ motoristaSelecionado.data }}</span>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Entrega from '../../../../services/entrega'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'MapaEntregas',

    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data () {
      return {
        corPrimaria: localStorage.corPrimaria || '#1976D2',
        motoristas: [],
        motoristaSelecionado: null,
        busca: '',
        carregando: false,
        map: null,
        markers: {},
        pingInterval: null,
        contagemInterval: null,
        intervaloPing: 120,
        contagemRegressiva: 120,
        opcoesIntervalo: [
          { label: '2 minutos', valor: 120 },
          { label: '3,5 minutos', valor: 210 },
        ],

        snackbar: {
          visible: false,
          color: 'success',
          message: '',
          timeout: 3000,
        },
      }
    },

    computed: {
      motoristasFiltrados () {
        if (!this.busca) return this.motoristas

        const termo = this.busca.toLowerCase()
        return this.motoristas.filter(m =>
          (m.nome_motorista && m.nome_motorista.toLowerCase().includes(termo)) ||
          (m.nome_transportador && m.nome_transportador.toLowerCase().includes(termo)) ||
          (m.id_romaneio && String(m.id_romaneio).toLowerCase().includes(termo)),
        )
      },
    },

    mounted () {
      if (!localStorage.tokencontrato) {
        localStorage.removeItem('username')
        this.$router.push('/login')
        return
      }

      eventEmit.$emit('atualizar_texto', 'Rastrear Entregas')
      this.iniciarMapa()
    },

    beforeDestroy () {
      clearInterval(this.pingInterval)
      clearInterval(this.contagemInterval)
    },

    methods: {
      async iniciarMapa () {
        await this.$nextTick()

        const center = { lat: -20.7523, lng: -42.8733 }

        this.map = new window.google.maps.Map(document.getElementById('mapMotoristas'), {
          center,
          zoom: 13,
          mapId: '6ae34073275a94e4',
          zoomControl: true,
          streetViewControl: true,
          mapTypeControl: false,
          fullscreenControl: true,
        })

        await this.buscarPosicoes()
        this.iniciarPing()
      },

      iniciarPing () {
        this.contagemRegressiva = this.intervaloPing

        this.contagemInterval = setInterval(() => {
          this.contagemRegressiva--
          if (this.contagemRegressiva <= 0) {
            this.contagemRegressiva = this.intervaloPing
          }
        }, 1000)

        this.pingInterval = setInterval(() => {
          this.buscarPosicoes()
        }, this.intervaloPing * 1000)
      },

      reiniciarPing () {
        clearInterval(this.pingInterval)
        clearInterval(this.contagemInterval)
        this.iniciarPing()
      },

      async buscarPosicoes () {
        this.carregando = true

        try {
          const resposta = await Entrega.showUltimaLocalizacao(localStorage.tokencontrato)

          if (resposta.data.success && Array.isArray(resposta.data.data)) {
            this.atualizarMotoristas(resposta.data.data)
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.showSnackbar('error', 3000, 'Erro ao buscar posições dos motoristas')
          }
        } finally {
          this.carregando = false
          this.contagemRegressiva = this.intervaloPing
        }
      },

      atualizarMotoristas (dados) {
        this.motoristas = dados

        if (this.motoristaSelecionado) {
          const atualizado = dados.find(m => m.id_romaneio === this.motoristaSelecionado.id_romaneio)
          if (atualizado) {
            this.motoristaSelecionado = atualizado
          } else {
            this.motoristaSelecionado = null
          }
        }

        if (dados.length > 0 && Object.keys(this.markers).length === 0) {
          const primeiro = dados[0]
          this.map.setCenter({
            lat: parseFloat(primeiro.latitude),
            lng: parseFloat(primeiro.longitude),
          })
        }

        this.removerMarcadoresAntigos(dados)

        dados.forEach(motorista => {
          if (this.markers[motorista.id_romaneio]) {
            this.moverMarcador(motorista)
          } else {
            this.criarMarcador(motorista)
          }
        })
      },

      removerMarcadoresAntigos (dadosAtuais) {
        const idsAtivos = new Set(dadosAtuais.map(m => String(m.id_romaneio)))

        Object.keys(this.markers).forEach(idRomaneio => {
          if (!idsAtivos.has(idRomaneio)) {
            this.markers[idRomaneio].map = null
            delete this.markers[idRomaneio]
          }
        })
      },

      criarMarcador (motorista) {
        const marker = new window.google.maps.marker.AdvancedMarkerElement({
          position: {
            lat: parseFloat(motorista.latitude),
            lng: parseFloat(motorista.longitude),
          },
          map: this.map,
          title: motorista.nome_motorista,
          content: this.criarElementoMarcador(motorista),
          zIndex: 0,
        })

        marker.addListener('gmp-click', () => {
          this.selecionarMotorista(motorista)
        })

        this.markers[motorista.id_romaneio] = marker
      },

      moverMarcador (motorista) {
        const marker = this.markers[motorista.id_romaneio]
        if (!marker) return

        const novaLat = parseFloat(motorista.latitude)
        const novaLng = parseFloat(motorista.longitude)

        const novaPosicao = new window.google.maps.LatLng(novaLat, novaLng)
        const posicaoAtual = marker.position

        marker.content = this.criarElementoMarcador(motorista)

        if (
          posicaoAtual &&
          Math.abs(posicaoAtual.lat - novaLat) < 0.00001 &&
          Math.abs(posicaoAtual.lng - novaLng) < 0.00001
        ) return

        this.animarMovimento(marker, posicaoAtual, novaPosicao, 1500)
      },

      animarMovimento (marker, origem, destino, duracao) {
        const inicio = performance.now()

        const lat0 = typeof origem.lat === 'function' ? origem.lat() : origem.lat
        const lng0 = typeof origem.lng === 'function' ? origem.lng() : origem.lng
        const lat1 = typeof destino.lat === 'function' ? destino.lat() : destino.lat
        const lng1 = typeof destino.lng === 'function' ? destino.lng() : destino.lng

        const animar = (agora) => {
          const progresso = Math.min((agora - inicio) / duracao, 1)
          const ease = 1 - Math.pow(1 - progresso, 3)

          marker.position = {
            lat: lat0 + (lat1 - lat0) * ease,
            lng: lng0 + (lng1 - lng0) * ease,
          }

          if (progresso < 1) requestAnimationFrame(animar)
        }

        requestAnimationFrame(animar)
      },

      getStatusRomaneioColor (status) {
        const s = String(status || '').toLowerCase()
        switch (s) {
          case 'rota': return '#FFA500'
          case 'pausado': return '#FF8A80'
          case 'aberta': return '#1976D2'
          case 'finalizado': return '#1D9E75'
          default: return '#1976D2'
        }
      },

      criarElementoMarcador (motorista) {
        const selecionado = this.motoristaSelecionado && this.motoristaSelecionado.id_romaneio === motorista.id_romaneio
        const cor = selecionado ? '#EA4335' : this.getStatusRomaneioColor(motorista.status_romaneio)

        const tamanho = selecionado ? '42px' : '36px'
        const iconSize = selecionado ? '20' : '18'
        const sombra = '0 2px 6px rgba(0,0,0,0.3)'
        const zIndex = selecionado ? 'z-index:999;' : ''

        const wrapper = document.createElement('div')
        wrapper.style.cssText = `display:flex;flex-direction:column;align-items:center;cursor:pointer;${zIndex}`

        wrapper.innerHTML = `
          <div style="
            background:${cor};
            border-radius:50% 50% 50% 0;
            width:${tamanho};
            height:${tamanho};
            display:flex;
            align-items:center;
            justify-content:center;
            box-shadow:${sombra};
            transform:rotate(-45deg);
            border:2px solid white;
            transition:all 0.2s ease;
          ">
            ${
          selecionado
            ? `
                  <div style="
                    transform:rotate(45deg);
                    width:14px;
                    height:14px;
                    border-radius:50%;
                    background:white;
                  "></div>
                `
            : `
                  <svg style="transform:rotate(45deg);" width="${iconSize}" height="${iconSize}" viewBox="0 0 24 24" fill="white">
                    <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zm-1.5 1.5l1.96 2.5H17V9.5h1.5zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm13 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>
                  </svg>
                `
        }
          </div>

          <div style="
            margin-top:4px;
            background:white;
            color:#333;
            font-size:11px;
            font-weight:700;
            padding:2px 6px;
            border-radius:4px;
            box-shadow:0 1px 4px rgba(0,0,0,.25);
            white-space:nowrap;
          ">
            ${motorista.placa || ''}
          </div>
        `
        return wrapper
      },

      selecionarMotorista (motorista) {
        this.motoristaSelecionado = motorista

        this.motoristas.forEach(m => {
          const marker = this.markers[m.id_romaneio]
          if (marker) {
            marker.content = this.criarElementoMarcador(m)
            marker.zIndex = m.id_romaneio === motorista.id_romaneio ? 999 : 0
          }
        })

        if (this.map) {
          this.map.panTo({
            lat: parseFloat(motorista.latitude),
            lng: parseFloat(motorista.longitude),
          })
          this.map.setZoom(15)
        }
      },

      hexToRgba (hex, opacity) {
        const r = parseInt(hex.slice(1, 3), 16)
        const g = parseInt(hex.slice(3, 5), 16)
        const b = parseInt(hex.slice(5, 7), 16)
        return `rgba(${r}, ${g}, ${b}, ${opacity})`
      },

      getAvatarBg (motorista) {
        const corBase = this.getStatusRomaneioColor(motorista.status_romaneio)
        return this.hexToRgba(corBase, 0.15)
      },

      getIniciais (nome) {
        if (!nome) return '?'
        return nome
          .split(' ')
          .slice(0, 2)
          .map(p => p[0])
          .join('')
          .toUpperCase()
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.color = color
        this.snackbar.timeout = timeout
        this.snackbar.message = message
        this.snackbar.visible = true
      },
    },
  }
</script>

<style scoped>
  .mapa-body {
    display: flex;
    flex: 1;
    overflow: hidden;
  }

  .mapa-sidebar {
    width: 360px;
    min-width: 260px;
    display: flex;
    flex-direction: column;
    border-right: 1px solid rgba(0,0,0,0.08);
    background: #fafafa;
    overflow: hidden;
  }

  .mapa-sidebar__search {
    padding: 10px 10px 8px;
    border-bottom: 1px solid rgba(0,0,0,0.06);
  }

  .mapa-sidebar__loading {
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #888;
  }

  .mapa-sidebar__lista {
    overflow-y: auto;
    flex: 1;
  }

  .mapa-sidebar__vazio {
    padding: 20px;
    text-align: center;
    font-size: 13px;
    color: #aaa;
  }

  .mapa-driver-card {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    cursor: pointer;
    border-bottom: 0.5px solid rgba(0,0,0,0.05);
    transition: background 0.15s;
  }

  .mapa-driver-card:hover {
    background: #f0f4f8;
  }

  .mapa-driver-card--selecionado {
    background: #e8f0fe;
  }

  .mapa-driver-card__avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    flex-shrink: 0;
  }

  .mapa-driver-card__info {
    flex: 1;
    min-width: 0;
  }

  .mapa-driver-card__nome {
    font-size: 13px;
    font-weight: 500;
    color: #222;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mapa-driver-card__sub {
    font-size: 11px;
    color: #888;
    margin-top: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mapa-driver-card__data {
    font-size: 10px;
    color: #aaa;
    margin-top: 2px;
  }

  .mapa-driver-card__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .mapa-area {
    flex: 1;
    position: relative;
    overflow: hidden;
  }

  .mapa-canvas {
    width: 100%;
    height: 100%;
  }

  .mapa-detalhe-card {
    position: absolute;
    bottom: 28px;
    right: 12px;
    width: 240px;
    background: white;
    border: 0.5px solid rgba(0,0,0,0.12);
    border-radius: 12px;
    z-index: 10;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  }

  .mapa-detalhe-card__header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 12px 8px;
    border-bottom: 0.5px solid rgba(0,0,0,0.07);
  }

  .mapa-detalhe-card__avatar {
    width: 32px !important;
    height: 32px !important;
    font-size: 11px !important;
  }

  .mapa-detalhe-card__titulo {
    flex: 1;
    min-width: 0;
  }

  .mapa-detalhe-card__nome {
    font-size: 13px;
    font-weight: 600;
    color: #222;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mapa-detalhe-card__transportadora {
    font-size: 11px;
    color: #888;
    margin-top: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mapa-detalhe-card__body {
    padding: 8px 12px 12px;
  }

  .mapa-detalhe-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    padding: 5px 0;
    border-bottom: 0.5px solid rgba(0,0,0,0.04);
  }

  .mapa-detalhe-row:last-child {
    border-bottom: none;
  }

  .mapa-detalhe-row--destaque {
    background: #f9f9f9;
    margin: 0 -12px;
    padding: 5px 12px;
    border-radius: 0 0 8px 8px;
  }

  .mapa-detalhe-row__label {
    color: #888;
    flex-shrink: 0;
    margin-right: 8px;
  }

  .mapa-detalhe-row__val {
    color: #222;
    font-weight: 500;
    text-align: right;
  }

  .slide-up-enter-active,
  .slide-up-leave-active {
    transition: all 0.25s ease;
  }

  .slide-up-enter,
  .slide-up-leave-to {
    transform: translateY(12px);
    opacity: 0;
  }

  .mapa-spinner {
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  @media (max-width: 680px) {
    .mapa-detalhe-card {
      width: calc(100% - 24px);
      right: 12px;
      left: 12px;
    }
  }

  .mapa-overlay-atualizacao {
    position: absolute;
    top: 12px;
    right: 60px;

    z-index: 5;

    display: flex;
    align-items: center;
    gap: 8px;

    background: rgba(255,255,255,0.96);
    backdrop-filter: blur(8px);

    padding: 6px 10px;

    border-radius: 999px;

    box-shadow:
      0 2px 8px rgba(0,0,0,.12),
      0 1px 2px rgba(0,0,0,.08);
  }

  .mapa-overlay-atualizacao__header {
    display: flex;
    align-items: center;
    gap: 4px;

    font-size: 12px;
    font-weight: 600;
    color: #555;
  }

  .mapa-overlay-atualizacao__select {
    width: 130px;
    height: 30px;
  }

  .mapa-overlay-atualizacao__select >>> .v-input__slot {
    min-height: 28px !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .mapa-overlay-atualizacao__select >>> .v-select__selection {
    font-size: 12px;
  }

</style>
